import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  users: [],
  usersTeam: [],
  usersManage: [],
  userDetail: {},
  listUsers: [],
  total: 0
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_USERS:
        draft.users = action.users;
        break;
      case Types.GET_LIST_USER:
        draft.listUsers = action.payload;
        break;
      case Types.GET_LIST_MANAGER:
        draft.usersManage = action.payload.data;
        draft.total = action.payload.total;
        break;
      case Types.GET_LIST_USER_TEAM:
        draft.usersTeam = action.payload.data;
        draft.total = action.payload.total;
        break;
      case Types.GET_USER_DETAIL:
        draft.userDetail = action.payload;
        break;
      default:
        return state;
    }
  })
}

